import {BrowserView} from "react-device-detect";
import ContactBar from "./components/contactBar";
import MainBar from "./components/mainBar";

import "./style.scss";

const Header = () => {
    return (
        <header className='header-template-2'>
            {/*<ContactBar/>*/}
            <MainBar/>
        </header>
    );
}

export default Header;